export enum MyWalletsBoxElementType {
    THIRDWEB = 'THIRDWEB',
    METAMASK = 'METAMASK',
    COINBASE = 'COINBASE',
    CONNECT_WALLET = 'ADD_WALLET'
}